import { NotificationTemplateMetadataListQuery } from '../../lib/graphql';

import styles from './notification_preview.module.css';

type MetadataItem = NotificationTemplateMetadataListQuery['notificationTemplateMetadataList'][number];

interface NotificationPreviewListProps {
  templateNames: string[];
  selectedTemplate: string | null;
  onSelectTemplate: (name: string) => void;
  metadataList: MetadataItem[];
}

export const NotificationPreviewList = ({
  templateNames,
  selectedTemplate,
  onSelectTemplate,
  metadataList,
}: NotificationPreviewListProps) => {
  return (
    <div className={styles.sidebar}>
      {templateNames.map((name) => {
        const metadata = metadataList.find((m) => m.template_name === name) ?? null;
        const displayTitle = metadata?.title ?? null;
        const isActive = selectedTemplate === name;

        return (
          <div
            key={name}
            className={`${styles.sidebarItem} ${isActive ? styles.sidebarItemActive : ''}`}
            onClick={() => onSelectTemplate(name)}>
            {displayTitle !== null ? (
              <>
                <span className={styles.sidebarItemTitle}>{displayTitle}</span>
                <span className={styles.sidebarItemName}>{name}</span>
              </>
            ) : (
              name
            )}
          </div>
        );
      })}
    </div>
  );
};
